<template>
    <SbModal
        centered
        hide-footer
        dialog-class="modal-full quote-chat-dialog"
        body-class="d-flex flex-column quote-chat-body"
        title="Chatt"
        v-model="modalOpen"
    >
        <quote-chat-messages-chat
            class="flex-grow-1"
            :disable-pdf-viewer="disablePdfViewer"
            :quote-key="quoteKey"
            :is-customer="isCustomer"
            :is-template="isTemplate"
            :mark-as-seen="modalOpen"
            :should-reload-messages="modalOpen"
            :chat-available-for-customer="chatAvailableForCustomer"
            :chat-attachments-available="chatAttachmentsAvailable"
            :attachment-accept="attachmentAccept"
            :chat-response-time-text="chatResponseTimeText"
            :seller="seller"
        ></quote-chat-messages-chat>
    </SbModal>
</template>

<style lang="scss" scoped>
:deep(.quote-chat-dialog .modal-content) {
    height: calc(var(--doc-height, 100dvh) - 16px);
    min-height: 0;
}

:deep(.quote-chat-body) {
    min-height: 0;
    overflow: hidden;
}
</style>

<script setup>
import { ref, watch } from "vue";
const emit = defineEmits(["update:modelValue"]);
const props = defineProps({
    modelValue: { default: undefined },
    quoteKey: String,
    disablePdfViewer: Boolean,
    isCustomer: {
        type: Boolean,
        default: false,
    },
    isTemplate: {
        type: Boolean,
        default: false,
    },
    chatAvailableForCustomer: {
        type: Boolean,
        default: true,
    },
    chatAttachmentsAvailable: {
        type: Boolean,
        default: false,
    },
    attachmentAccept: {
        type: String,
        default: "",
    },
    chatResponseTimeText: {
        type: String,
    },
    seller: {
        type: String,
    },
});
const modalOpen = ref(
    props.modelValue
);
watch(() => props.modelValue, syncModalOpen);
function syncModalOpen() {
    const value =
        props.modelValue;
    if (modalOpen.value !== value) {
        modalOpen.value = value;
    }
}
watch(modalOpen, (newValue, oldValue) => {
    if (newValue != oldValue) {
        emit("update:modelValue", newValue);
    }
});
</script>
